module.exports = __webpack_public_path__ + "static/img/14.2bbf0b9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/2/sp/14.png
// module id = C7WG
// module chunks = 0